export default "__VITE_ASSET__DLDWS125__"